import { render, staticRenderFns } from "./AmetrasInfoBoxTemplate.vue?vue&type=template&id=9fa5bb6c&"
import script from "./AmetrasInfoBoxTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasInfoBoxTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
